export default [
  // 直接跳转到下载界面
  {
    path: '/landing/straight',
    component: () => import('../view/landing/straight'),
    name: 'straight',
    meta: { pageName: 'page_straight' }
  },
  // 下载界面
  {
    path: '/landing/straight/result',
    component: () => import('../view/landing/straight/result.vue'),
    name: 'straightResult',
    meta: { pageName: 'page_straight_result' }
  },
  // 颜值贷落地页
  {
    path: '/landing/yzd',
    component: () => import('../view/landing/yzd'),
    name: 'landingYzd',
    meta: { pageName: 'page_landing_yzd' }
  },
  // 颜值贷免息落地页
  {
    path: '/landing/yzd/mianxi',
    component: () => import('../view/landing/yzd/mianxi'),
    name: 'landingYzdMianxi',
    meta: { pageName: 'page_landing_yzd_mianxi' }
  },
  // 颜值贷跳转的中间页
  {
    path: '/landing/yzd/middle',
    component: () => import('../view/landing/yzd/middle'),
    name: 'landingYzdMiddle',
    meta: { pageName: 'page_landing_yzd_middle' }
  },
  // 通用落地页1
  {
    path: '/landing/general',
    // component: () => import('../view/landing/general'),
    component: () => import('../view/landing/general3'),
    name: 'landingGeneral',
    meta: { pageName: 'page_general' }
  },
  // 通用落地页1结果页
  {
    path: '/landing/general/result',
    // component: () => import('../view/landing/general/result'),
    component: () => import('../view/landing/general3/result'),
    name: 'landingGeneralResult',
    meta: { pageName: 'page_general_result' }
  },
  // 通用落地页2
  {
    path: '/landing/general2',
    component: () => import('../view/landing/general2'),
    name: 'landingGeneral2',
    meta: { pageName: 'page_general2' }
  },
  // 通用落地页2结果页
  {
    path: '/landing/general2/result',
    component: () => import('../view/landing/general2/result'),
    name: 'landingGeneral2Result',
    meta: { pageName: 'page_general2_result' }
  },
  // 通用落地页3
  {
    path: '/landing/general3',
    component: () => import('../view/landing/general3'),
    name: 'landingGeneral3',
    meta: { pageName: 'page_general3' }
  },
  // 通用落地页3结果页
  {
    path: '/landing/general3/result',
    component: () => import('../view/landing/general3/result'),
    name: 'landingGeneral3Result',
    meta: { pageName: 'page_general3_result' }
  },
  // 通用落地页4
  {
    path: '/landing/general4',
    component: () => import('../view/landing/general4'),
    name: 'landingGeneral4',
    meta: { pageName: 'page_general4' }
  },
  // 通用落地页4结果页
  {
    path: '/landing/general4/result',
    component: () => import('../view/landing/general4/result'),
    name: 'landingGeneral4Result',
    meta: { pageName: 'page_general4_result' }
  },
  // 通用落地页5
  {
    path: '/landing/general5',
    component: () => import('../view/landing/general5'),
    name: 'landingGeneral5',
    meta: { pageName: 'page_general5' }
  },
  // 通用落地页5结果页
  {
    path: '/landing/general5/result',
    component: () => import('../view/landing/general5/result'),
    name: 'landingGeneral5Result',
    meta: { pageName: 'page_general5_result' }
  },
  {
    path: '/landing/general6',
    component: () => import('../view/landing/general6'),
    name: 'landingGeneral6',
    meta: { pageName: 'page_general6' }
  },
  {
    path: '/landing/general6/result',
    component: () => import('../view/landing/general6/result'),
    name: 'landingGeneral6Result',
    meta: { pageName: 'page_general6_result' }
  },
  {
    path: '/landing/general7',
    component: () => import('../view/landing/general7'),
    name: 'landingGeneral7',
    meta: { pageName: 'page_general7' }
  },
  {
    path: '/landing/general7/result',
    component: () => import('../view/landing/general7/result'),
    name: 'landingGeneral7Result',
    meta: { pageName: 'page_general7_result' }
  },
  {
    path: '/landing/general8',
    component: () => import('../view/landing/general8'),
    name: 'landingGeneral8',
    meta: { pageName: 'page_general8' }
  },
  {
    path: '/landing/general8/result',
    component: () => import('../view/landing/general8/result'),
    name: 'landingGeneral8Result',
    meta: { pageName: 'page_general8_result' }
  },
  {
    path: '/landing/half_api/index',
    component: () => import('../view/landing/half-api/index'),
    name: 'landingHalfApiResult',
    meta: { pageName: 'page_half_api_result' }
  },
  {
    path: '/landing/common/result',
    component: () => import('../view/landing/common-landing/index'),
    name: 'landingCommonResult',
    meta: { pageName: 'landing_common_result' }
  },
  // 通用落地页5结果页
  {
    path: '/landing/sms',
    component: () => import('../view/landing/sms/index'),
    name: 'landingSms',
    meta: { pageName: 'page_landing_ms' }
  },
  // 落地页拦截页
  {
    path: '/landing/intercept',
    component: () => import('../view/landing/intercept'),
    name: 'intercept',
    meta: { pageName: 'page_landing_intercept' }
  },
  {
    path: '/landing/data-distribution',
    component: () => import('../view/landing/data-distribution'),
    name: 'dataDistribution',
    meta: { pageName: 'page_landing_data_distribution' }
  },
  {
    path: '/landing/data-distribution/result',
    component: () => import('../view/landing/data-distribution/result'),
    name: 'dataDistributionResult',
    meta: { pageName: 'page_landing_data_distribution_result' }
  },
  {
    path: '/landing/active-share',
    component: () => import('../view/landing/active-share'),
    name: 'landingActiveShare',
    meta: { pageName: 'page_active_share' }
  },
  {
    path: '/landing/active-share/result',
    component: () => import('../view/landing/active-share/result'),
    name: 'landingActiveShareResult',
    meta: { pageName: 'page_active_share_result' }
  }, {
    path: '/landing/ios',
    component: () => import('../view/landing/ios'),
    name: 'landingios',
    meta: { pageName: 'page_ios' }
  }, {
    path: '/landing/refund-auth',
    component: () => import('../view/landing/refund-auth'),
    name: 'landingRefundAuth',
    meta: { pageName: 'page_refund_auth' }
  }
]